const shadowMixin = {
  data() {
    return {
      shadow: {
        left: false,
        right: false,
        left_pos: 0,
        right_pos: 0,
      },
    };
  },
  methods: {
    toggleShadow() {
      const hasHorizontalScrollbar = this.$refs.scrollContainer.clientWidth < this.$refs.scrollContainer.scrollWidth;

      const scrolledFromLeft = this.$refs.scrollContainer.offsetWidth + this.$refs.scrollContainer.scrollLeft;

      const scrolledToLeft = this.$refs.scrollContainer.scrollLeft === 0;
      const scrolledToRight = scrolledFromLeft >= this.$refs.scrollContainer.scrollWidth - 4;

      this.shadow.left = hasHorizontalScrollbar && !scrolledToLeft;
      this.shadow.right = hasHorizontalScrollbar && !scrolledToRight;

      this.shadowPosition();
    },
    shadowPosition() {
      this.shadow.left_pos = 0;
      this.shadow.right_pos = 0;

      const firstRow = document.querySelector('.tl-table-sticky__scroll')?.querySelector('tbody tr');
      let stickyLeft;
      let stickyRight;
      if (firstRow) {
        stickyLeft = firstRow.querySelectorAll('td.tl-table-sticky__left');
        stickyRight = firstRow.querySelectorAll('td.tl-table-sticky__right');

        stickyLeft.forEach(element => {
          this.shadow.left_pos += element.offsetWidth;
        });

        stickyRight.forEach(element => {
          this.shadow.right_pos += element.offsetWidth;
        });
      }
    },
  },
};

const paginationMixin = {
  data() {
    return {
      metas: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        from: 1,
        to: 1,
        total: 1,
      },
    };
  },
  computed: {
    dataTotalPages() {
      return Math.ceil(this[this.dataPagination].length / this.metas.per_page);
    },
    dataRows() {
      return this[this.dataPagination].length;
    },
    dataPaginated() {
      return this[this.dataPagination].slice((this.metas.current_page - 1) * this.metas.per_page, this.metas.current_page * this.metas.per_page);
    },
  },
  watch: {
    dataTotalPages(val) {
      this.metas.last_page = val || 1;
    },
    dataRows(val) {
      this.metas.total = val || 1;
    },
    dataPaginated(val) {
      const totalPrevious = this.metas.per_page * (this.metas.current_page - 1);
      this.metas.from = totalPrevious + 1;
      this.metas.to = totalPrevious + val.length;
    },
  },
  methods: {
    update({ page, limit }) {
      this.metas.current_page = page;
      this.metas.per_page = limit;
    },
    search(val) {
      this.metas.current_page = 1;
      this[this.dataPagination] = this[this.allData].filter(item => {
        return item[this.searchBy].toLowerCase().includes(val.toLowerCase());
      });
    },
  },
};

const sortMixin = {
  data() {
    return {
      filter: { sortBy: '', sortDirection: '' },
    };
  },
  computed: {
    sort() {
      if (this.filter.sortBy && this.filter.sortDirection) return `${this.filter.sortBy}-${this.filter.sortDirection}`;
      return '';
    },
  },
  methods: {
    getIcon(field) {
      if (this.filter.sortBy === field) {
        return this.filter.sortDirection === 'desc' ? 'sort-descending' : 'sort-ascending';
      }
      return 'sort-default';
    },
    updateFilterSort(field) {
      const { sortBy: currentBy, sortDirection: currentDirection } = this.filter;

      this.filter.sortDirection = 'asc';
      if (currentBy === field) this.filter.sortDirection = currentDirection === 'asc' ? 'desc' : 'asc';
      this.filter.sortBy = field;
    },
    async sortList(by, data = this.dataPagination) {
      await this.updateFilterSort(by);
      this.sortData(data, by, this.filter.sortDirection);
    },
    sortData(data, field, sort) {
      // manual sort
      const sorted = this[data].sort((a, b) => {
        if (sort === 'desc') {
          return b[field]?.toString().localeCompare(a[field]?.toString());
        }
        return a[field]?.toString().localeCompare(b[field]?.toString());
      });
      this[data] = sorted;
    },
  },
};

export { shadowMixin, paginationMixin, sortMixin };
